<template>
  <ul
    class="products container"
    :class="{
      'products--grid': layout === 'grid' || mq.mdPlus,
      'products--narrow': narrow === true,
    }"
  >
    <li v-for="product in productsWithSkeleton" :key="product.id">
      <ProductTile
        v-if="!product.skeleton"
        :product="product"
        :show-one-photo="showOnePhoto"
        :flat-lays="flatLays"
      />
      <SkeletonProductTile v-else />
    </li>
  </ul>
</template>

<script>
import { PER_PAGE } from "@/helpers/pagination.js";
import ProductTile from "@/components/ProductTile.vue";
import SkeletonProductTile from "@/components/skeleton/SkeletonProductTile.vue";

export default {
  name: "ProductGrid",
  components: {
    ProductTile,
    SkeletonProductTile,
  },
  inject: ["mq"],
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: "grid",
      validator(value) {
        return ["list", "grid"].includes(value);
      },
    },
    showOnePhoto: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    flatLays: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    skeletonProducts() {
      return new Array(PER_PAGE).fill({ skeleton: true });
    },
    productsWithSkeleton() {
      const products = [...this.products];
      if (this.loading) {
        return [...products, ...this.skeletonProducts];
      }
      return products;
    },
  },
};
</script>

<style lang="scss" scoped>
.products.container {
  @include respond-below(md) {
    padding: 0;
  }
}

.products--grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2px;

  @include respond-above(md) {
    padding: 0 20px;
    grid-template-columns: repeat(4, 1fr);
  }

  ::v-deep(.product__info) {
    @include respond-above(md) {
      padding-bottom: 120px;
    }
  }

  &.products--narrow {
    grid-template-columns: repeat(2, 1fr);
    gap: 2px;
    padding: 0;
  }
}
</style>
